/*
 * @Author: 朱占伟
 * @LastEditors: 朱占伟
 * @description: 路由实体部分
 * @Date: 2021-10-18 16:08:48
 * @LastEditTime: 2021-10-18 16:27:44
 */

import routerConfig from "./route.config"
export default class Routes extends React.Component {
  constructor(props) {
    super(props)
  }
  render() {
    return (
      // <ReactRouter.BrowserRouter>
      <React.Fragment>
        {/* 容器 */}
        <ReactRouter.Switch>
          {
            routerConfig.map((item) => {
              if (item.redirect) {
                return (
                  <ReactRouter.Redirect to={item.redirect} key={item.name} />
                )
              } else {
                return (
                  <ReactRouter.Route exact={item.exact} path={item.path} key={item.name} render={props => {
                    document.title = item?.meta?.title || 'Howso@ALGO - 零门槛玩转AI开发'
                    return <item.component {...props}></item.component>
                  }} />
                )
              }
            })
          }
        </ReactRouter.Switch>

      </React.Fragment>
      // </ReactRouter.BrowserRouter>
    );
  }
}